module.exports = __webpack_public_path__ + "img/kallas.01ec6a1b.svg";